import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

// Styles
import './payment-details.scss';

// Components
import { StripeAccount } from './children/stripe-account/stripe-account';
import { AppCurrency } from './children/app-currency/app-currency';

// Store entities
import { getCurrencyState } from '../../../../store/currency/currency.selectors';

type TPaymentDetailsProps = {};

export const PaymentDetails: FC<TPaymentDetailsProps> = (
  {}: TPaymentDetailsProps
) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [stripeAccountHash, setStripeAccountHash] = useState<string | null>(null);

  const { currencies, currentCurrency } = useSelector(getCurrencyState);

  const checkConnectStripeAccountState = (): void => {
    const accountHash = searchParams.get('code');

    if (!accountHash) return;
    setStripeAccountHash(accountHash);
  }

  useEffect(() => {
    checkConnectStripeAccountState();
  }, []);

  return (
    <div className="payment-details">
      <div className="payment-details--header">
        <div className="header-title">
          Payment Details
        </div>
      </div>

      <div className="payment-details--body">
        <div className="body-column">
          <StripeAccount stripeAccountHash={ stripeAccountHash }/>
        </div>
        <div className="body-column">
          { currentCurrency && <AppCurrency currentCurrency={ currentCurrency } availableCurrencies={ currencies }/> }
        </div>
      </div>
    </div>
  );
}
